import { CURRENCY_FORMAT_OPTIONS } from '~/constants'

export const getCurrencyFormatOptions = (minValue?: number, maxValue?: number) => {
  const { min, max } = CURRENCY_FORMAT_OPTIONS.valueRange
  return {
    ...CURRENCY_FORMAT_OPTIONS,
    valueRange: { ...CURRENCY_FORMAT_OPTIONS.valueRange, min: minValue ?? min, max: maxValue ?? max }
  }
}
